import { Typography } from '@mui/material';
import { connect, type ConnectedProps } from 'react-redux';
import { deleteMember } from '@/slices/members';
import { type ModalContentProps } from '../../../state';
import { ModalLayout } from '../../layouts';

type Props = ModalContentProps & ConnectedProps<typeof connector>;

const DeleteMemberModal = ({
  closeModal,
  modalData: { propertyId, memberId, memberName, propertyName },
  deleteMember,
}: Props) => {
  const handleAccept = () => {
    deleteMember({ propertyId, memberId });
    closeModal();
  };

  const modalTitle =
    memberName && propertyName
      ? `Remove ${memberName} from ${propertyName} property?`
      : 'Delete Member';

  return (
    <ModalLayout
      closeModal={closeModal}
      title={modalTitle}
      onAccept={handleAccept}
      acceptText="Remove"
      onCancel={closeModal}
      cancelText="Cancel"
    >
      <Typography>The user will lose access to this property</Typography>
    </ModalLayout>
  );
};

const connector = connect(null, { deleteMember });

export default connector(DeleteMemberModal);
